import React from 'react';
import Loading from '../../../../_shared/components/Loading';
import {
  LoadingContentContainer,
  LoadingContentInfo,
  LoadingContentRow,
  LoadingFooter,
  LoadingTradeCard
} from './Styles';

const LoadingContent = ({ width, height }) => {
  return (
    <LoadingContentRow>
      <Loading width={width} height={height} />
    </LoadingContentRow>
  );
};

const PendingCardLoading = () => {
  return (
    <LoadingTradeCard>
      <LoadingContentContainer>
        <div>
          <Loading width="144px" height="130px" />
        </div>
        <LoadingContentInfo>
          <LoadingContent width="360px" height="20px" />
          <LoadingContent width="360px" height="20px" />
          <LoadingContent width="360px" height="20px" />
        </LoadingContentInfo>
      </LoadingContentContainer>

      <LoadingFooter>
        <Loading width="517px" height="35px" />
      </LoadingFooter>
    </LoadingTradeCard>
  );
};

export default PendingCardLoading;
